// @flow

import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {useAsyncActions} from 'app/utils/redux';

import {selectFolderWithAncestors} from './selectors';
import {fetchFolderByHashid} from './actions';
import {type FolderRecurrentParentType} from './types';

export function useFolderWithParents(
  hashid: string | null | void
): null | void | FolderRecurrentParentType {
  const actions = useAsyncActions({fetchFolderByHashid});

  useEffect(() => {
    if (hashid != null) {
      actions.fetchFolderByHashid(hashid);
    }
  }, [hashid]);

  return useSelector((state) => {
    if (hashid == null) {
      return null;
    }
    return selectFolderWithAncestors(hashid, state) || undefined;
  });
}
